import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {from, Observable, of, throwError} from 'rxjs';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {environment} from '../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ClientService {

    private httpOptions: any;
    token:any
    constructor(private httpClient: HttpClient,
                private authService: AuthService,
                private router: Router) {
    }


    clientRegistration(client: iClient): Observable<any> {
        return this.authService.post(`${environment.patientService}client`, client);
    }

    getAllClients(params?:any): Observable<any> {
        return this.authService.getP(`${environment.patientService}client/all`, params);
    }
    getAllPateint(params?:any): Observable<any> {
        return this.authService.getP(`${environment.patientService}client/all`, params);
    }

    deleteClient(params?:any): Observable<any> {
        return this.authService.delete(`${environment.patientService}client`, params);
    }

    getClientDetails(params?:any): Observable<any> {
        return this.authService.getP(`${environment.patientService}client`, params);
    }

    getClientRoles(params?:any): Observable<any> {
        return this.authService.getP(`${environment.userService}user/roles`, params);
    }

    getGroup(params?:any): Observable<any> {
        return this.authService.getP(`${environment.userService}user/roles`, params);
    }

    getGroupRoles(params?:any): Observable<any> {
        return this.authService.getP(`${environment.userService}user/roles`, params);
    }

    updateClient(body: any, params?:any): Observable<any> {
        return this.authService.put(`${environment.patientService}client`,body, params);
    }

    getUserClientDetails(params?:any): Observable<any> {
        return this.authService.getP(`${environment.patientService}client`, params);
    }

    clientTemplateUpload(data,params): Observable<any> {
        return this.authService.postD(`${environment.reportService}patientreport`, data, params);
    }

   /* getClientTemplate(params): Observable<any> {
        return this.authService.getP(`${environment.reportService}patientreport`, params);
    }*/

    getClientTemplate(params): Observable<HttpResponse<Blob>> {
        return this.authService.getView(`${environment.reportService}patientreport`, params, 'blob');
    }
}
